import React, { useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import './HeroSection.css';

const HeroSection = () => {


    useEffect(() => {
        const img = document.querySelector('.hero-section .carousel-item:first-child img');
        const mobileSrc = `${process.env.PUBLIC_URL}/images/FSS-movil.png`;
        const desktopSrc = `${process.env.PUBLIC_URL}/images/FullStackServices0.png`;
    
        const handleResize = () => {
          if (window.innerWidth <= 576) {
            img.src = mobileSrc;
          } else {
            img.src = desktopSrc;
          }
        };
    
        handleResize();
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

  return (
    <header className="hero-section text-white text-center" id="inicio">
    <div className="container-fluid px-0 contenedor-hero">
      <Carousel id="hero-carousel">
        <Carousel.Item>
        <img src={`${process.env.PUBLIC_URL}/images/FullStackServices0.png`} className="d-block w-100" alt="Full Stack service" />
          <Carousel.Caption>
            <h1 className="display-4 titulo-carrusel">Creación de Apps Web</h1>
            <p className="lead det-carrusel">Impulsa tu presencia online con páginas web y aplicaciones hermosas</p>
            <a href="#contact" className="btn btn-primary btn-lg btn-hero-contact">Contáctame</a>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img src={`${process.env.PUBLIC_URL}/images/SocialMediaServices1.png`} className="d-block w-100" alt="Social media manager" />
          <Carousel.Caption>
            <h1 className="display-4 titulo-carrusel">Potencia tu Marca</h1>
            <p className="lead det-carrusel">Destaca con estrategias efectivas de social media marketing</p>
            <a href="#contact" className="btn btn-primary btn-lg btn-hero-contact">Contáctame</a>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img src={`${process.env.PUBLIC_URL}/images/TutoriasServices3.jpg`} className="d-block w-100" alt="Tutorías service" />
          <Carousel.Caption>
            <h1 className="display-4 titulo-carrusel">Clases Personalizadas</h1>
            <p className="lead det-carrusel">Recibe tutorías online para avanzar en tu carrera</p>
            <a href="#contact" className="btn btn-primary btn-lg btn-hero-contact">Contáctame</a>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  </header>

  );
};

export default HeroSection;
